const BreadcrumbSkeleton = () => {
    return (
        <div className="skeleton-box w-44 h-7 rounded-2xl mt-2">
            <span />
        </div>
    )
}

export default BreadcrumbSkeleton;